<template>
<div>
  <v-row>
    <v-col cols="5" class="pt-0 pb-0">
      <p class="red--text">This information will go on the deed for the new owner name and address</p>
    </v-col>
    <v-col cols="7" class="pt-0 pb-0">
      <v-btn class="input-text-size" small text color="blue darken-1"
      @click="handlePrintRegistration">Print Registration</v-btn>
    </v-col>
    <v-col cols="6" class="pt-0 pb-0 mt-3">
      <v-row>
        <v-col cols="3" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-5"
          v-model.number="editedItem.regNumber" label="Reg #" type="number" :readonly="!editedItem._id" :tabindex="!editedItem._id ? -1 : 0"/>
        </v-col>
        <v-col cols="9" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-5"
          v-model="editedItem.bidderName" label="Bidder Name" v-uppercase="isEverythingToCaps" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.addressOne" label="Address 1" v-uppercase="isEverythingToCaps" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.addressTwo" label="Address 2" v-uppercase="isEverythingToCaps" />
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.city" label="City" v-uppercase="isEverythingToCaps" />
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.state" label="State" v-uppercase="isEverythingToCaps" />
        </v-col>
        <v-col cols="4" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
            label="Zip Code" v-model="editedItem.zipCode"
            @blur="zipFormatter('zipCode')" :value="formattedValues.zipCode"
            @focus="(e) => { zipUnformatter(e, 'zipCode') }" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.emailAddress" label="Email Address" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.phoneNumber" label="Phone Number" />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="6" class="pt-0 pb-0 mt-3">
      <v-row>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-5"
          v-model="editedItem.totalDeposits" label="Total Deposits" readonly tabindex="-1" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.totalWithdrawals" label="Total Withdrawals" readonly tabindex="-1" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.winningBidsTotal" label="Total of Winning Bids" readonly tabindex="-1" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
          v-model="editedItem.amountDueToBidder" label="Current Balance" readonly tabindex="-1" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-0">
          <v-btn class="input-text-size mt-n2"
          v-if="editedItem._id"
          small text color="blue darken-1"
          @click="handleAddDeposit"
        >
          Deposit
        </v-btn>
        <v-btn class="input-text-size mt-n2"
          v-if="editedItem._id"
          small text color="blue darken-1"
          @click="handleAddWithdrawal"
        >
          Withdrawal
        </v-btn>
        </v-col>
      </v-row>
  </v-col>
</v-row>
<CRUDList ref="bidderAmtDialogList" :canAdd="false" :canEdit="true"
  :canSave="true" :showSelect="false" :canDeleteInDialog="false"
  :enableFixedHeaders="true" :displayTopPagination="false" :headers="activityHeaders"
  :baseCrudKey="bidderActivityCrudKey" :hideDefaultFooter="true"
  tableWrapperDynamicClassname='elevation-0 ma-3 pt-0 pa-1 taxroll-table-wrapper'
  tableDynamicClassname='taxroll-custom-table' tableDynamicHeight="200"
  @onDoubleClicked="handleEditItem" @upsertItem="handleAddDepositOrWithdrawalEdit"
  :onlyDialogHeaderName="bidderAmtDialogHeader" dialogDynamicWidth='400'
  :defaultSortBy="defaultSortBy">
  <template v-slot:[`editedItem`]="{}">
    <v-text-field class="input-text-size ma-0 pa-0"
    v-model="bidderAmtDialogData.bidderActivityAmount" :label="bidderAmtDialogHeader" />
  </template>
  </CRUDList>
<CRUDDialog
  :baseCrudKey='bidderAmtDialog'
  :canSave="true"
  :onlyDialogHeaderName="bidderAmtDialogHeader"
  @upsertItem="handleAddDepositOrWithdrawal"
  dialogDynamicWidth='400'
><template v-slot:[`editedItem`]="{}">
  <v-text-field class="input-text-size ma-0 pa-0" @keydown.enter.prevent
   v-model="bidderAmtDialogData.bidderActivityAmount" :label="bidderAmtDialogHeader" />
 </template>
</CRUDDialog>
</div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import GlobalToCaps from '../../../../../util/shared/GlobalToCaps.mixin.vue';
import {
  amountFormat, amountToNumber, zipDeFormat, zipFormat,
} from '../../../../../util/shared/vue-global';
import CRUDDialog from '../../../../common/base/crud-2.0/CRUDDialog.vue';
import { bidderActivityHeader } from '../../deliquentUtils/deliquent.utils';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';

export default {
  name: 'BidderRegistrationDialog',
  mixins: [GlobalToCaps],
  components: {
    CRUDDialog,
    CRUDList,
  },
  data() {
    return {
      activityHeaders: bidderActivityHeader,
      bidderAmtDialogData: {
        bidderActivityAmount: '',
      },
      formattedValues: {
        zipCode: '',
      },
      bidderAmtDialog: 'bidderAmtDialogCrudKey',
      bidderActivityCrudKey: 'bidderActivityCrudKey',
      bidderAmtDialogHeader: 'Deposit Amount',
      isItDepositOrWithdrawal: 'deposit',
      isItEditOrNot: false,
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'BidderRegistrationDialog',
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'criteria',
      'index',
      'isVisible',
    ]),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKeyAdditional);
      },
      set(value) {
        this.setCriteria([this.baseCrudKeyAdditional, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    getBidderActivityItems() {
      return this.items(this.bidderActivityCrudKey) || [];
    },
    defaultSortBy() {
      return [
        {
          column: 'logDate',
          direction: 'asc',
        },
      ];
    },
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', ['setItem', 'setItems', 'setIsVisible']),
    zipUnformatter(e, val) {
      const formatedAmt = zipDeFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
      // settimout is required to make it select after the zip state is set
      setTimeout(() => e.target.select(), 50);
    },
    zipFormatter(val) {
      const formatedAmt = zipFormat(this.editedItem[val]);
      this.editedItem[val] = formatedAmt;
      this.formattedValues[val] = formatedAmt;
    },
    resetBidderAmtDialogData() {
      this.bidderAmtDialogData = {
        bidderActivityAmount: '',
      };
    },
    handleAddDeposit() {
      this.bidderAmtDialogHeader = 'Deposit Amount';
      this.isItDepositOrWithdrawal = 'deposit';
      this.resetBidderAmtDialogData();
      this.setIsVisible([this.bidderAmtDialog, true]);
    },
    handleAddWithdrawal() {
      this.bidderAmtDialogHeader = 'Withdrawal Amount';
      this.isItDepositOrWithdrawal = 'withdrawal';
      this.resetBidderAmtDialogData();
      this.setIsVisible([this.bidderAmtDialog, true]);
    },
    handleAddDepositOrWithdrawal() {
      if (this.editedItem._id) {
        const updatedItem = {
          _id: this.editedItem._id,
          type: this.isItDepositOrWithdrawal,
          amount: amountToNumber(this.bidderAmtDialogData.bidderActivityAmount || 0),
        };
        this.$emit('handleLogActivity', updatedItem);
      }
    },
    handleAddDepositOrWithdrawalEdit(item) {
      if (item._id && this.editedItem._id) {
        const updatedItem = {
          mainId: this.editedItem._id,
          _id: item._id,
          amount: amountToNumber(this.bidderAmtDialogData.bidderActivityAmount || 0),
        };
        this.$emit('handleLogAndRecalculateBalance', updatedItem);
      }
    },
    handleEditItem(item) {
      this.isItEditOrNot = true;
      if (item._id) {
        this.bidderAmtDialogData.bidderActivityAmount = item.amount;
        if (item.type === 'deposit') {
          this.bidderAmtDialogHeader = 'Edit Deposit Amount';
        } else {
          this.bidderAmtDialogHeader = 'Edit Withdrawal Amount';
        }
      }
    },
    handlePrintRegistration() {
      this.$emit('upsertItem', true);
    },
  },
};
</script>
